<template>
    <div>
        <div v-for="record in records">
            <div class="row no-wrap">
                Record {{ record.id }} <template v-if="true">(altered)</template>
                <q-btn small label="Revert changes">Revert changes</q-btn>
                <q-btn small label="Delete all">Delete all</q-btn>
            </div>
            <div class="row no-wrap">
                <q-table :config="config" :columns="columns" :data="record.data">
                    <div slot="col-delete" slot-scope="cell">
                        <q-checkbox v-model="cell.row.delete" @change="wtf" />
                    </div>
                    <div slot="col-modify" slot-scope="cell">
                        <q-checkbox v-model="cell.row.modify" />
                    </div>
                    <div slot="col-report" slot-scope="cell">
                        <q-checkbox v-model="cell.row.report" />
                    </div>
                </q-table>
            </div>
        </div>
    </div>
</template>

<script type="javascript">
import { QLayout, QBtn, QCheckbox } from 'quasar';

export default {
    name: 'record-table',
    components: {
        QLayout,
        QBtn,
        QCheckbox
    },
    props: [
        'records'
    ],
    methods: {
        wtf() {
            console.log(this.records);
        }
    },
    data() {
        return {
            config: {
                rowHeight: '65px'
            },
            columns: [
                {
                    label: 'Variable',
                    field: 'variable'
                },
                {
                    label: 'Value',
                    field: 'value'
                },
                {
                    label: 'Delete',
                    field: 'delete'
                },
                {
                    label: 'Modify',
                    field: 'modify'
                },
                {
                    label: 'Report',
                    field: 'report'
                }
            ]
        };
    }
};
</script>
